import { FormViolation, GlobalRouteData } from '@domain/models/shared.models';

export class SetRouteData {
  static readonly type = '[Global] Set Route Data';
  constructor(public data: GlobalRouteData) {}
}

export class SetFormViolations {
  static readonly type = '[Global] Set Form Violations';
  constructor(public data: FormViolation[] | undefined) {}
}
